import * as React from 'react';
import { withRouter } from 'react-router';
import TokenService from 'src/services/token/TokenService';
import { goToLogin } from 'src/utils/navigation';

import Home from './pages/Home';
import Content from './pages/Content';
import Static from './pages/Static';

import { Route, Redirect, Switch } from 'react-router-dom';
import env from './shared/env';
import { connect } from 'react-redux';
import { localeActions, noCountryLanguageSel } from './store/modules/locale';
import i18n from './translation/i18n';

class App extends React.Component<any, {}> {
  public language: string;

  constructor(props: {}) {
    super(props);
  }

  private checkUserAccount = () => {
    if (localStorage.getItem('isSamsungUser')) {
      document.body.classList.add('special-body-easy-notification');
    }
    if (!this.props.location.hash.includes('login')) {
      if ('accessToken' in localStorage) {
        const decodedToken = TokenService.decodeToken(
          localStorage.getItem('accessToken')
        );
        if ('accountId' in decodedToken === false) {
          goToLogin();
        }
      } else if ('specialUserAccessToken' in localStorage) {
        const decodedToken = TokenService.decodeToken(
          localStorage.getItem('specialUserAccessToken')
        );
        if ('accountId' in decodedToken === false) {
          goToLogin();
        }
      }
    }
  };

  private getSiteLanguage = () => {
    if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
      return 'en';
    }
    const currentUrl = window.location.pathname.split('/');
    const languageFromUrl = currentUrl[2];
    if (this.props?.lng === languageFromUrl) {
      return this.props?.lng;
    }
    switch (languageFromUrl) {
      case 'en':
        return 'en';
        break;
      case 'fr':
        return 'fr';
        break;
      default:
        return 'en';
        break;
    }
  };

  public componentDidMount = () => {
    this.checkUserAccount();

    const script = document.createElement('script');
    script.src = env.REACT_APP_PAYSIMPLE_URL;
    // script.async = true;

    document.body.appendChild(script);
    if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
      this.props.changelanguage('en-US');
      return 'en';
    }
    if (this.language !== this.props?.lng) {
      switch (this.language) {
        case 'en':
          this.props?.changelanguage(
            env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'en-CA' : 'en-US'
          );
          return 'en';
          break;
        case 'fr':
          this.props?.changelanguage('fr-CA');
          return 'fr';
          break;
        default:
          this.props?.changelanguage(
            env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'en-CA' : 'en-US'
          );
          return 'en';
          break;
      }
    } else {
      this.props?.changelanguage(
        env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'en-CA' : 'en-US'
      );
      return 'en';
    }
  };

  public componentDidUpdate = (prevProps: any) => {
    this.checkUserAccount();
  };

  public render() {
    this.language = this.getSiteLanguage() || this.props?.lng;
    const siteCountry =
      env.REACT_APP_BASE_ENVIRONMENT === 'CA'
        ? `/ca/${this.language}/`
        : '/us/';
    return (
      <Switch>
        <Route path={`${siteCountry}`} exact={true} component={Home} />
        <Route path={`${siteCountry}content`} component={Content} />
        <Route
          path="/"
          exact={true}
          render={() => <Redirect push={false} to={`${siteCountry}`} />}
        />
        <Route component={Static} />
      </Switch>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    lng: noCountryLanguageSel(state)
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  changelanguage: (lang: string) => {
    dispatch(localeActions.changeLanguage(lang));
  },
  setLanguage: (lang: string) => {
    dispatch(localeActions.setLanguage(lang));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(props => <App {...props} />));
